// extracted by mini-css-extract-plugin
export default {"card":"InputCard_card__Dl5nH","orderlist":"InputCard_orderlist__Z3xde"};